// import { Link, useLocation } from "react-router-dom";
// import {
//   FaTachometerAlt,
//   FaBuilding,
//   FaPlusCircle,
//   FaUserFriends,
//   FaChalkboardTeacher,
//   FaCalendarCheck,
//   FaClock,
//   FaLock,
//   FaSignOutAlt,
//   FaChartBar
// } from "react-icons/fa";

// export default function CourtOwnerSidebar() {
//   const { pathname } = useLocation();

//   const active = (path) =>
//     pathname === path
//       ? "bg-[#495057] text-white font-semibold shadow-inner"
//       : "text-gray-300 hover:bg-[#343a40] hover:text-white transition-all duration-200";

//   const logout = () => {
//     localStorage.removeItem("courtOwnerToken");
//     window.location.href = "/courtowner/login";
//   };

//   return (
//     <>
//       {/* --- Sidebar --- */}
//       <aside className="fixed top-0 left-0 w-64 bg-[#1c2331] text-white h-screen flex flex-col justify-between shadow-2xl z-50">
//         {/* ---- Header ---- */}
//         <div>
//           <div className="p-5 border-b border-gray-700">
//             <h2 className="text-2xl font-bold text-white tracking-wide">
//               Court Owner
//             </h2>
//           </div>

//           {/* ---- Navigation ---- */}
//           <nav className="flex flex-col mt-4 space-y-1 text-[16px]">
//             <Link
//               to="/courtowner/dashboard"
//               className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
//                 "/courtowner/dashboard"
//               )}`}
//             >
//               <FaTachometerAlt size={18} /> Dashboard
//             </Link>

//             <Link
//               to="/courtowner/venues"
//               className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
//                 "/courtowner/venues"
//               )}`}
//             >
//               <FaBuilding size={18} /> Venues
//             </Link>

//             <Link
//               to="/courtowner/add-venue"
//               className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
//                 "/courtowner/add-venue"
//               )}`}
//             >
//               <FaPlusCircle size={18} /> Add Venue
//             </Link>
// {/* 
//             <Link
//               to="/courtowner/coaches"
//               className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
//                 "/courtowner/coaches"
//               )}`}
//             >
//               <FaChalkboardTeacher size={18} /> Coaches
//             </Link> */}

//             <Link
//               to="/courtowner/users"
//               className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
//                 "/courtowner/users"
//               )}`}
//             >
//               <FaUserFriends size={18} /> Users
//             </Link>

//             <Link
//               to="/courtowner/bookings"
//               className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
//                 "/courtowner/bookings"
//               )}`}
//             >
//               <FaCalendarCheck size={18} /> Bookings
//             </Link>

//             <Link
//               to="/courtowner/manage-slots"
//               className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
//                 "/courtowner/manage-slots"
//               )}`}
//             >
//               <FaClock size={18} /> Manage Slots
//             </Link>
//             <Link
//               to="/courtowner/reports"
//               className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
//                 "/courtowner/reports"
//               )}`}
//             >
//               <FaChartBar size={18} /> Reports
//             </Link>

//             {/* <Link
//               to="/courtowner/lockedusers"


              
//               className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
//                 "/courtowner/lockedusers"
//               )}`}
//             >
//               <FaLock size={18} /> Locked Users
//             </Link> */}
//           </nav>
//         </div>

//         {/* ---- Logout ---- */}
//         <div className="p-5 border-t border-gray-700">
//           <button
//             onClick={logout}
//             className="w-full flex items-center justify-center gap-2 bg-red-600 text-white py-2 rounded-md hover:bg-red-700 transition-all font-semibold text-lg"
//           >
//             <FaSignOutAlt /> Logout
//           </button>
//         </div>
//       </aside>

//       {/* --- Content Offset Fix --- */}
//       <style>
//         {`
//           body {
//             margin-left: 16rem; /* same as w-64 = 256px */
//           }
//         `}
//       </style>
//     </>
//   );
// }
// src/components/courtowner/CourtOwnerSidebar.js
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaBuilding,
  FaPlusCircle,
  FaUserFriends,
  FaCalendarCheck,
  FaClock,
  FaSignOutAlt,
  FaChartBar,
  FaBars,
  FaTimes,
  FaUserCircle,FaBell
} from "react-icons/fa";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { MdBlock, MdOutlineBlock } from "react-icons/md";
import { courtOwnerApi } from "../../api/courtOwnerApi"; // ✅ import API

export default function CourtOwnerSidebar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  // 🔹 Profile info for header
  const [ownerName, setOwnerName] = useState("");
  const [ownerRole, setOwnerRole] = useState("VENUE MANAGER"); // fallback text
  const [profileComplete, setProfileComplete] = useState(true);

useEffect(() => {
  const loadProfile = async () => {
    try {
      const data = await courtOwnerApi.getProfile();
      setOwnerName(data?.name || "");
      setOwnerRole(data?.businessName || "VENUE MANAGER");
      setProfileComplete(data?.profileComplete ?? true);
    } catch (err) {
      console.error("Failed to load owner profile in sidebar:", err);
    }
  };

  loadProfile(); // initial

  // 🔥 Listen for profile update event from profile page
  const handleProfileUpdated = () => {
    loadProfile();
  };

  window.addEventListener("courtowner-profile-updated", handleProfileUpdated);

  return () => {
    window.removeEventListener("courtowner-profile-updated", handleProfileUpdated);
  };
}, []);


  const active = (path) =>
    pathname === path
      ? "bg-[#495057] text-white font-semibold shadow-inner"
      : "text-gray-300 hover:bg-[#343a40] hover:text-white transition-all duration-200";

  const logout = () => {
    localStorage.removeItem("courtOwnerToken");
    window.location.href = "/courtowner/login";
  };

  // 🔒 Block navigation if profile is incomplete (except profile page)
  const handleNavClick = (path) => (e) => {
    if (!profileComplete && path !== "/courtowner/profile") {
      e.preventDefault();
      alert("Please complete your profile before accessing other features.");
      setIsOpen(false);
      navigate("/courtowner/profile");
      return;
    }
    setIsOpen(false);
  };

  return (
    <>
      {/* ---- Toggle Button (only visible when sidebar is closed) ---- */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed top-5 right-4 z-[9999] bg-[white] text-[#0d2149] p-2 rounded-md lg:hidden"
        >
          <FaBars size={20} />
        </button>
      )}

      {/* ---- Sidebar ---- */}
      <aside
        className={`fixed top-0 left-0 w-64 bg-[#03153b] text-white h-screen flex flex-col justify-between shadow-2xl transform transition-transform duration-300 z-50 
        ${isOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}
      >
        <div>
          {/* ---- Profile Header ---- */}
          <div className="p-4 border-b border-gray-700 flex items-center gap-3">
            <div className="flex items-center gap-3 bg-[#102553] px-3 py-2 rounded-lg w-full">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                  <FaUserCircle className="text-white text-3xl" />
                </div>
              </div>

              <div className="flex-1">
                <p className="text-sm font-semibold leading-tight uppercase">
                  {ownerName || "Loading..."}
                </p>
                <p className="text-[11px] uppercase tracking-[0.18em] text-gray-300">
                  {ownerRole}
                </p>

                <Link
                  to="/courtowner/profile"
                  onClick={handleNavClick("/courtowner/profile")}
                  className="mt-1 inline-flex items-center px-3 py-1 text-[11px] font-semibold rounded-full bg-white text-[#03153b] hover:bg-gray-200"
                >
                  VIEW PROFILE
                </Link>

                {!profileComplete && (
                  <p className="mt-1 text-[10px] text-yellow-300 font-medium">
                    Complete your profile to unlock all features.
                  </p>
                )}
              </div>
            </div>

            {/* Close button (mobile only) */}
            <button
              onClick={() => setIsOpen(false)}
              className="lg:hidden text-gray-300 hover:text-white ml-1 self-start"
            >
              <FaTimes size={18} />
            </button>
          </div>

          {/* ---- Nav Links ---- */}
          <nav className="flex flex-col mt-4 space-y-1 text-[16px]">
            <Link
              to="/courtowner/dashboard"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/dashboard"
              )}`}
              onClick={handleNavClick("/courtowner/dashboard")}
            >
              <FaTachometerAlt size={18} /> Dashboard
            </Link>

            <Link
              to="/courtowner/venues"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/venues"
              )}`}
              onClick={handleNavClick("/courtowner/venues")}
            >
              <FaBuilding size={18} /> Venues
            </Link>

            <Link
              to="/courtowner/add-venue"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/add-venue"
              )}`}
              onClick={handleNavClick("/courtowner/add-venue")}
            >
              <FaPlusCircle size={18} /> Add Venue
            </Link>

            <Link
              to="/courtowner/users"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/users"
              )}`}
              onClick={handleNavClick("/courtowner/users")}
            >
              <FaUserFriends size={18} /> Users
            </Link>

            <Link
              to="/courtowner/bookings"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/bookings"
              )}`}
              onClick={handleNavClick("/courtowner/bookings")}
            >
              <FaCalendarCheck size={18} /> Bookings
            </Link>

            <Link
              to="/courtowner/manage-slots"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/manage-slots"
              )}`}
              onClick={handleNavClick("/courtowner/manage-slots")}
            >
              <FaClock size={18} /> Manage Slots
            </Link>

            <Link
              to="/courtowner/blocksingleslot"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/blocksingleslot"
              )}`}
              onClick={handleNavClick("/courtowner/blocksingleslot")}
            >
              <MdBlock size={18} /> Block slots
            </Link>

            <Link
              to="/courtowner/blockbulkslots"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/blockbulkslots"
              )}`}
              onClick={handleNavClick("/courtowner/blockbulkslots")}
            >
              <MdOutlineBlock size={18} /> Bulk Block
            </Link>

            <Link
              to="/courtowner/directory"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/directory"
              )}`}
              onClick={handleNavClick("/courtowner/directory")}
            >
              <MdOutlineLibraryAdd size={18} /> Directory
            </Link>

            <Link
              to="/courtowner/reports"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/reports"
              )}`}
              onClick={handleNavClick("/courtowner/reports")}
            >
              <FaChartBar size={18} /> Reports
            </Link>
             <Link
              to="/courtowner/notifications"
              className={`flex items-center gap-3 px-5 py-2 rounded-md ${active(
                "/courtowner/notifications"
              )}`}
              onClick={() => setIsOpen(false)}
            >
              <FaBell size={18} /> Notifications
            </Link>
          </nav>
        </div>

        {/* ---- Logout ---- */}
        <div className="p-5 border-t border-gray-700">
          <button
            onClick={logout}
            className="w-full flex items-center justify-center gap-2 bg-red-600 text-white py-2 rounded-md hover:bg-red-700 transition-all font-semibold text-lg"
          >
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </aside>
    </>
  );
}
